import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ReadMorePopup = ({ children, show, setShow }) => {
  const handleClose = () => setShow(false);

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      aria-labelledby="ccw-read-more-dialog-title"
      scroll="paper"
      PaperProps={{
        className: "ccw-dialog ccw-shared-dialog ccw-read-more-dialog"
      }}
      BackdropProps={{ className: "ccw-shared-dialog__backdrop" }}
      maxWidth={false}
    >
      <DialogTitle component="div" className="ccw-dialog__header ccw-shared-dialog__header">
        <h2 id="ccw-read-more-dialog-title" className="ccw-shared-dialog__title">
          Full details
        </h2>
        <IconButton
          className="ccw-shared-dialog__close"
          aria-label="Close details"
          onClick={handleClose}
        >
          <CloseIcon aria-hidden="true" />
        </IconButton>
      </DialogTitle>
      <DialogContent className="ccw-dialog__body ccw-shared-dialog__body ccw-read-more-dialog__body">
        {children}
      </DialogContent>
    </Dialog>
  );
};

ReadMorePopup.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired
};

export default ReadMorePopup;
